import { http } from 'core/utils/httpClient';
import type { MangoCallInfo } from 'models/mangoCall';
import type { MangoCallInfoResponse } from './dtoModels/mangoCall/mangoCallResponse';
import type { GetMangoCallsRequest } from './dtoModels/mangoCall/getMangoCallsRequest';
import type { PaginatedList } from './dtoModels/paginatedList';

const mapMangoCall = (source: MangoCallInfoResponse): MangoCallInfo => ({
  ...source,
  dateOfCall: new Date(source.dateOfCall),
  order:
    source.order != null
      ? { ...source.order, dateCreate: new Date(source.order.dateCreate) }
      : null,
});

export async function getMangoCallsAsync(
  request: GetMangoCallsRequest
): Promise<PaginatedList<MangoCallInfo>> {
  const { data } = await http.get<PaginatedList<MangoCallInfoResponse>>(
    'mango-office/calls',
    { params: request }
  );
  return { ...data, items: data.items.map(mapMangoCall) };
}

export async function getMangoCallAsync(id: number): Promise<MangoCallInfo> {
  const { data } = await http.get<MangoCallInfoResponse>(`mango-office/calls/${id}`);
  return mapMangoCall(data);
}

export async function createMangoCallOrderAsync(id: number): Promise<void> {
  await http.post(`mango-office/calls/${id}/order`);
}

export async function getOrderMangoCallsAsync(orderId: number): Promise<MangoCallInfo[]> {
  const { data } = await http.get<MangoCallInfoResponse[]>(
    `orders/${orderId}/mango-calls`
  );
  return data.map(mapMangoCall);
}
